export function delay(ms = 1000) {
    return new Promise(resolve => {
        const timeout = setTimeout(() => {
            resolve(null)
            clearTimeout(timeout)
        }, ms)
    })
}
